import axios from 'axios';

export default {
	postSubmitForm(cb, { data, ClientToken }) {
		axios
			.post('/api/DigitalLead',
				data, {
					headers: {
						Authorization: `Bearer ${ClientToken}`,
						Dealer: sessionStorage.getItem('dealer')
					} })
			.then(response => response.data)
			.then(data => {
				cb(data);
			})
			.catch(err => cb(err.response));
	},
};
